const events = {
  submitted: 'EHYA5V3G-KdLayHmz',
  telegram: 'EHYA5V3G-6QB3PQ4w',
  whatsapp: 'EHYA5V3G-R48fsfKd',
  max: 'EHYA5V3G-e7jYFS4R'
}

function trackTelegramEvent (name) {
  try {
    if (typeof window !== 'undefined' && typeof window.tgp === 'function' && events[name]) {
      window.tgp('event', events[name])
    }
  } catch (error) {
    console.warn('Telegram pixel event failed:', error)
  }
}

module.exports = { trackTelegramEvent }
